import React from 'react';

import useTr from 'editor/src/util/useTr';

import styles from './FieldGroupTooltip.module.scss';
import shared from './ReflowTooltip.module.scss';

function FieldGroupTooltip() {
  const tr = useTr();
  return (
    <div className={shared.overlay}>
      <div className={styles.demo} aria-hidden="true">
        <div className={styles.group}>
          <div className={styles.header}>
            <span>{tr('editor-field-group-demo-contact', 'Contact details')}</span>
            <span className={styles.count}>2</span>
            <span className={styles.chevron} />
          </div>
          <div className={styles.fields}>
            <div className={styles.field}>
              <span>{tr('editor-field-group-demo-name', 'Name')}</span>
              <div>Alex Taylor</div>
            </div>
            <div className={styles.field}>
              <span>{tr('editor-field-group-demo-email', 'Email')}</span>
              <div>alex@example.com</div>
            </div>
          </div>
        </div>
        <div className={styles.nextGroup}>
          <span>{tr('editor-field-group-demo-company', 'Company details')}</span>
          <span>⌄</span>
        </div>
      </div>
      <div className={shared.container}>
        <div className={shared.title}>{tr('editor-personalization-add-field-group', 'Add field group')}</div>
        <div className={shared.description}>
          {tr(
            'editor-field-group-demo-description',
            'Keep related fields together. Customers can expand a group to edit its fields, then collapse it to focus on the next one.',
          )}
        </div>
        <div className={shared.hint}>
          {tr('editor-field-group-demo-hint', 'Give your group a name, then choose the fields to include.')}
        </div>
      </div>
    </div>
  );
}

export default React.memo(FieldGroupTooltip);
